// @flow

import {
	SelectBaseStrategy,
	DEFAULT_SIZE_RESULT,
} from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import type { ISelectStrategy } from 'rgs-nfd-ui-kit/ko-components/select/index.flow';
import type {
	HouseModel,
} from 'app-my-account/services/kladr/api-models/kladr.flow';
import ko from 'rgs-knockout';
import type { SelectBaseStrategyOptions } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import { AddressSettlement } from 'app-my-account/models/address';

export type StrategyHousesOptions = SelectBaseStrategyOptions<HouseModel> & {
	settlement: AddressSettlement,
	onClickItem: (street: HouseModel)=>Promise<void>,
	onClickCancel: ()=>void,
}

export class StrategyHouses extends SelectBaseStrategy<HouseModel>
	implements ISelectStrategy<HouseModel> {

	withSearch = ko.observable(true);
	pathToId = 'Kladr';
	pathToName = 'Name';
	minLengthSearchWord = 1;

	_options: StrategyHousesOptions;

	async onClickItem (house: HouseModel) {
		await super.onClickItem(house);

		await this._options.onClickItem(house);
	}

	setCurrentHouse (house: HouseModel) {
		this.currentValue(house);
	}

	onClickCancel () {
		super.onClickCancel();

		this._options.onClickCancel();
	}

	async _fetch (search: string, take: number = DEFAULT_SIZE_RESULT, from: number = 0) {
		const { Items } = await this._options.fetchSearch({ search, take, from });
		const house = {Name: search, Kladr: null, PostCode: null};
		let items = Items;

		const withSameName = Items.find(house => house.Name === search);

		if (!withSameName) {
			items = [house, ...Items];
		} else if (Items.length === 0) {
			items = [house];
		}

		this.items(items);
		this.total(items.length);
	}
}

